import Vue from "vue";
import axios from "axios";
import router from "../router/index";
import { debounce } from "throttle-debounce";
import ElementUI from "element-ui";

// 超时设定
axios.defaults.timeout = 60000000000000;

// 创建
const $axios = axios.create({
  headers: {
    "Content-Type": "application/json",
    Accept: "text/html, */*",
    "X-Requested-With": "XMLHttpRequest",
    'Cache-Control': 'max-age=10' // http 资源在客户端缓存时长
  },
  baseURL: "/manager",
});

// 请求拦截器
$axios.interceptors.request.use((config) => {
  let token = localStorage.getItem("token");
  if (token) {
    config.headers["token"] = token;
  }
  return config;
});

/* 会话失效弹窗提示 */
const timeoutMessageBox = debounce(500, () => {
  ElementUI.MessageBox.alert("您的登录已经超时，请点击按钮重新登录", "提示", {
    center: true,
    confirmButtonText: "重新登录",
    callback: () => {
      router.push("/login");
    },
  });
});

// 添加响应拦截器 code码后期和后端约定
$axios.interceptors.response.use(
  (response) => {
    if (response.data.code === 403) {
      timeoutMessageBox();
    }
    return response;
  },
  (error) => {
    Vue.nextTick(() => {
      if (error.response) {
        switch (error.response.code) {
          case 403: {
            timeoutMessageBox();
            break;
          }
          case 404: {
            break;
          }
          case 500: {
            break;
          }
          default: {
            break;
          }
        }
      }
    });
    return Promise.reject(error);
  }
);

/* 引入ajax请求方案 */
export function ajax(config) {
  config.instance = this;
  return $axios(config);
}
